import React from 'react'
import { Stack, Typography } from '@mui/material'
import { InfoIcon } from '../../icons'

export const InfoText: React.FC<{ children: string }> = ({ children }) => {
  return (
    <Stack direction={'row'} color={'#A4A4A4'} spacing={1} justifyContent={'center'} py={2}>
      <InfoIcon />
      <Typography fontWeight={600}>{children}</Typography>
    </Stack>
  )
}
